import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=33cd93b6&scoped=true&"
import script from "./SalesPage.vue?vue&type=script&lang=js&"
export * from "./SalesPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesPage.vue?vue&type=style&index=0&id=33cd93b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cd93b6",
  null
  
)

export default component.exports